import type { ConversationAccess } from "@rakazo/chat-ui/workspace-result";
import { conversationReferenceInput } from "@rakazo/chat-ui/workspace-result";
import { createSpaceRpc } from "./rpc";

export const authorizeConversation: ConversationAccess = async (input) => {
  // Additive API method, supplied by the separate shared/API deliverable.
  const client = createSpaceRpc(input.recipient.spaceId) as unknown as {
    threads: { reference(input: ReturnType<typeof conversationReferenceInput>): Promise<unknown> };
  };
  await client.threads.reference(conversationReferenceInput(input.source));
};
